export const SET_STATUS="app/clients/SET_STATUS"
export const NEXT_PAGE="app/clients/NEXT_PAGE"
export const BACK_PAGE="app/clients/BACK_PAGE"
export const RESET_PAGE="app/clients/RESET_PAGE"
export const CLIENTS_LOADING="app/clients/CLIENTS_LOADING"
export const SET_SEARCH="app/clients/SET_SEARCH"
export const SET_SEARCH_VIEW="app/clients/SET_SEARCH_VIEW"
